import React from 'react'
import { HelpTooltip } from '@/components/HelpTooltip'

/**
 * The heading above a band of cards: title, optional help, an optional one-line subtitle, and a
 * right-hand slot for a link or a count. Shared by the main dashboard and the market overview so
 * the two read as one product.
 */
export default function SectionHeading({
  title,
  subtitle,
  help,
  id,
  children,
}: {
  title: string
  subtitle?: React.ReactNode
  help?: { content: string; learnMore?: string }
  /** Anchor target for in-page links. */
  id?: string
  children?: React.ReactNode
}) {
  return (
    <div className="mb-3 flex flex-wrap items-end justify-between gap-x-4 gap-y-2">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h2 id={id} className="text-sm font-semibold text-foreground">
            {title}
          </h2>
          {help && <HelpTooltip content={help.content} learnMore={help.learnMore} />}
        </div>
        {subtitle && <p className="mt-0.5 text-xs text-muted-foreground">{subtitle}</p>}
      </div>
      {children}
    </div>
  )
}
